import { render, staticRenderFns } from "./PostView.vue?vue&type=template&id=9a0f8e4e"
import script from "./PostView.vue?vue&type=script&lang=js"
export * from "./PostView.vue?vue&type=script&lang=js"
import style0 from "./PostView.vue?vue&type=style&index=0&id=9a0f8e4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports